var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _text, _text2, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _text3, _text4, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _text5, _text6, _path32, _text7, _path33, _text8, _path34, _text9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem1Ch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 750 289"
    },
    viewBox: "0 0 750 289",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .st0{fill:#999}.st1{fill:#333}.st2{font-family:&apos;ArialUnicodeMS&apos;}.st3{font-size:15.279px}.st5{fill:#369;fill-opacity:.502}.st6{fill:#fff}.st7{font-size:11.4815px}\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M247.1 110.5V91.8h-45.7v1.7h44v15.3h-44v1.7h45.7zM542.6 77.3v-1.7H429.1v34.8h113.4v-1.7H430.8V77.3h111.8zM532.5 70v-6.5H367.8V70h164.7m-1.7-4.8v3.1H369.5v-3.1h161.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M530.8 68.3v-3.1H369.5v3.1h161.3z",
    className: "st0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M318.9 91.2c.5.8 1.9 3.1 4.1 7 2.4 4.3 4.5 8.1 6.5 11.4h3.6L320.7 88h-6.8l-12.4 21.6h3.6c1.9-3.3 4.1-7.1 6.5-11.4 2.2-3.8 3.6-6.2 4.1-7h3.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M542.7 110.4v-1.7H201.4v1.7h341.3zM233.8 92.6l-4.1-7-4.1 7h8.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M228.8 85.1l-4.8 8.3h11l-5.4-9.5-.8 1.2m-1.8 6.7l2.5-4.4 2.5 4.4h-5zM444.4 76.5l-4.1-7.1-4.1 7.1h8.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M440.2 69.3l-5.6 7.9h11.2l-5.6-7.9m-2.7 6.5l2.7-3.9 2.7 3.9h-5.4zM394.6 80.9V69h-5.1v11.9h5.1zM524.9 59.6v-7.5h-5.1v7.5h5.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M522.5 63.7l4.6-4.6h-9.3l4.7 4.6zM343.6 110.4V97.3h-50.4v13.1h50.4M341.9 99v9.7h-47V99h47z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M341.9 108.7V99h-47v9.7h47z",
    className: "st1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M319.4 82.3h-3.7v10.4h3.7V82.3m-2.1 1.7h.3v7h-.3v-7z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M406.6 86.5V80H213.8v6.5h192.8m-1.7-4.8v3.1H215.5v-3.1h189.4z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M404.9 84.8v-3.1H215.5v3.1h189.4z",
    className: "st0"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "st2 st3",
    transform: "matrix(1.0002 0 0 1 536.1328 63.3359)"
  }, "\n    x\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "st2 st3",
    transform: "matrix(1.0002 0 0 1 346.1309 105.686)"
  }, "\n    100 \u516C\u65A4\n  ")), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M247.1 176.1v-18.8h-45.7v1.7h44v15.4h-44v1.7h45.7zM542.6 142.8v-1.7H429.1v35h113.4v-1.7H430.8v-31.6h111.8zM532.5 135.5v-6.3H367.8v6.3h164.7m-1.7-4.6v2.9H369.5v-2.9h161.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M530.8 133.8v-2.9H369.5v2.9h161.3z",
    className: "st0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M318.8 156.8c.5.8 1.9 3.2 4.1 7.1 2.4 4.3 4.5 8.1 6.5 11.4h3.6l-12.2-21.6H314l-12.4 21.6h3.6c1.9-3.3 4.1-7.1 6.5-11.4 2.2-3.9 3.6-6.3 4.1-7.1h3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M542.7 176.1v-1.7H201.4v1.7h341.3zM233.8 158.1l-4.1-7-4.1 7h8.2z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M228.8 150.6l-4.8 8.3h11l-5.4-9.5-.8 1.2m-1.8 6.6l2.5-4.4 2.5 4.4h-5zM479.2 142l-4.1-7.1-4.1 7.1h8.2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M475.1 134.9l-5.4 7.9h11l-5.6-7.9m-2.6 6.5l2.6-3.7 2.6 3.7h-5.2zM394.6 146.6v-11.9h-5.1v11.9h5.1zM524.9 125.4v-7.6h-5.1v7.6h5.1z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M522.5 129.5l4.6-4.8h-9.3l4.7 4.8zM293.2 163v13.1h50.4V163h-50.4m1.7 11.4v-9.7h47v9.7h-47z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M294.9 164.7v9.7h47v-9.7h-47z",
    className: "st1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M319.4 148h-3.7v10.4h3.7V148m-2.1 1.7h.3v7h-.3v-7z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M213.8 145.5v6.5h192.7v-6.5H213.8m1.7 4.8v-3.1h189.3v3.1H215.5z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M215.5 147.2v3.1h189.3v-3.1H215.5z",
    className: "st0"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "st2 st3",
    transform: "matrix(1.0002 0 0 1 536.1328 128.8359)"
  }, "\n    x\n  ")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "st2 st3",
    transform: "matrix(1.0002 0 0 1 346.1309 171.2358)"
  }, "\n    100 \u516C\u65A4\n  ")), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M247.1 241.7V223h-45.7v1.7h44V240h-44v1.7h45.7zM542.6 208.3v-1.7H429.1v35h113.4v-1.7H430.8v-31.6h111.8zM532.5 201.2v-6.5H367.8v6.5h164.7m-1.7-4.7v3.1H369.5v-3.1h161.3z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M530.8 199.5v-3.1H369.5v3.1h161.3z",
    className: "st0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M318.8 222.3c.5 1 1.9 3.3 4.1 7.1 2.4 4.3 4.5 8.1 6.5 11.4h3.6l-12.2-21.6H314l-12.4 21.6h3.6c1.9-3.3 4.1-7.1 6.5-11.4 2.2-3.8 3.6-6.2 4.1-7.1h3z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M542.7 241.7V240H201.4v1.7h341.3zM233.8 223.8l-4.1-7.1-4.1 7.1h8.2z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M229.6 215l-5.6 9.7h11l-5.4-9.7m-2.7 8l2.6-4.5 2.6 4.5h-5.2zM513.2 207.5l-4.1-7-4.1 7h8.2z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M514.8 208.4l-.8-1-4.8-6.8-4.8 6.8-.8 1h11.2m-8.2-1.4l2.6-3.8 2.6 3.8h-5.2zM394.6 212.1v-11.9h-5.1v11.9h5.1zM524.9 190.9v-7.5h-5.1v7.5h5.1z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M522.5 195l4.6-4.6h-9.3l4.7 4.6zM293.2 228.6v13.1h50.4v-13.1h-50.4m1.7 11.3v-9.7h47v9.7h-47z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M294.9 230.3v9.7h47v-9.7h-47z",
    className: "st1"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M319.4 213.6h-3.7V224h3.7v-10.4m-2.1 1.7h.3v7h-.3v-7z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M405.7 216.7v-4.6h-191v4.6h191z",
    style: {
      fill: "red"
    }
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M213.8 211.2v6.3h192.7v-6.3H213.8m1.7 4.6v-2.9h189.3v2.9H215.5z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M215.5 212.9v2.9h189.3v-2.9H215.5z",
    className: "st0"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "st2 st3",
    transform: "matrix(1.0002 0 0 1 536.1328 194.5361)"
  }, "\n    x\n  ")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "st2 st3",
    transform: "matrix(1.0002 0 0 1 346.1309 236.8862)"
  }, "\n    100 \u516C\u65A4\n  ")), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M587.7 57.9c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7 0 3.4 1.2 6.3 3.6 8.7 2.4 2.4 5.3 3.6 8.7 3.6s6.2-1.2 8.6-3.6c2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    className: "st5"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "st6 st2 st7",
    transform: "matrix(.9981 0 0 1 575.167 71.5181)"
  }, "\n    1\n  ")), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M587.7 123.7c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6s-3.6 5.3-3.6 8.7 1.2 6.3 3.6 8.7c2.4 2.4 5.3 3.6 8.7 3.6s6.2-1.2 8.6-3.6c2.4-2.4 3.6-5.3 3.6-8.7s-1.2-6.3-3.6-8.7z",
    className: "st5"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "st6 st2 st7",
    transform: "matrix(.9981 0 0 1 575.167 137.3179)"
  }, "\n    2\n  ")), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M587.7 189.5c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7s1.2 6.3 3.6 8.7c2.4 2.4 5.3 3.6 8.7 3.6s6.2-1.2 8.6-3.6c2.4-2.4 3.6-5.3 3.6-8.7s-1.2-6.3-3.6-8.7z",
    className: "st5"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "st6 st2 st7",
    transform: "matrix(.9981 0 0 1 575.167 203.1182)"
  }, "\n    3\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem1Ch);
export default __webpack_public_path__ + "static/media/item1ch.ba8ec5f9c66b13eab0549f1db72cb2da.svg";
export { ForwardRef as ReactComponent };